<template>
  <div class="common-page order-management">
    <div class="top-box">
      <div class="search-form-box">
        <el-row :gutter="30">
          <el-form inline>
            <el-col :span="5" v-if="companyType === '1'">
              <el-form-item label="分公司:">
                <el-select style="width: 100%" v-model="searchForm.belongCompanyId" placeholder="请选择">
                  <el-option
                    v-for="item in belongCompanyData"
                    :key="item.companyId"
                    :label="item.companyName"
                    :value="item.companyId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="订单编号:">
                <el-input
                  style="width: 100%"
                  clearable
                  v-model="searchForm.orderNo"
                  autocomplete="off"
                  placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="承运机构:" prop="driverCompanyId">
                <el-select
                  style="width: 100%"
                  v-model="searchForm.driverCompanyId"
                  filterable
                  allow-create
                  default-first-option
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="item in companyData"
                    :key="item.companyId"
                    :label="item.companyName"
                    :value="item.companyId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="回单方式:" prop="receiptWay">
                <el-select
                  style="width: 100%"
                  v-model="searchForm.receiptWay"
                  filterable
                  allow-create
                  default-first-option
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="item in $dict.receiptWayOptions"
                    :key="item.dictCode"
                    :label="item.dictLabel"
                    :value="item.dictCode"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="">
                <el-button type="primary" round icon="el-icon-search" @click="handleCheck()"></el-button>
                <el-button type="default" round icon="el-icon-refresh" @click="handleReset(['belongCompanyId'])"></el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </div>
      <div class="custom-tip">回单订单跟单仅展示订单要求纸质回单的订单，未确认的订单共 {{ unConfirm }} 条</div>
    </div>

    <div class="custom-table-box">
      <custom-table
        :data="tableData"
        :column="tableColumn"
        :total="tableOptions.total"
        :loading="tableOptions.loading"
        :page="tableOptions.pageNumber"
        :size="tableOptions.pageSize"
        :selection="false"
        @pagination="handleSizeChange">
        <template v-slot:receiptWay="{ row }">
          <span v-if="row.receiptWay ===  1">线下带回</span>
          <span v-if="row.receiptWay ===  0">待确认</span>
          <span v-if="row.receiptWay ===  2">快递寄回</span>
        </template>
        <template v-slot:startProvinceName="{ row }">
          <span>{{ row.startProvinceName }}{{ row.startCityName }}{{row.startDistrictName}}</span>
        </template>
        <template v-slot:endProvinceName="{ row }">
          <span>{{ row.endProvinceName }}{{ row.endCityName }}{{row.endDistrictName}}</span>
        </template>
        <template v-slot:operation="{ row }">
          <span
            :class="row.receiptWay === 0 ? 'operate-btn':'operate-btn-disabled'"
            @click="row.receiptWay === 0 ? handleGenDan(row):''">
            跟单
          </span>
          <span class="operate-btn" @click="openDetail(row)">详情</span>
        </template>
      </custom-table>
    </div>

    <!--    添加或编辑-->
    <addOrEdit ref="addOrEdit"></addOrEdit>
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import CustomDateRange from "@/components/CustomDateRange.vue";
import addOrEdit from "./addOrEdit.vue";
import { downloadTable, getOverview, getPage } from "./api";
import tableMixin from "@/mixin/tableMixin";
import { getAllTree, getTree } from "@/views/commonApi";

export default {
  name: "ShipperManagement",
  mixins: [tableMixin],
  components: {
    OperateBox,
    CustomTable,
    CustomDateRange,
    addOrEdit,
  },
  data() {
    return {
      getTableMethod: getPage,
      haveCompany: true,
      searchForm: {
        belongCompanyId: "",
        driverCompanyId: "",
        orderNo: "",
        receiptWay: "",
      },
      deptList: [],
      isImmediatelyGetData: true,
      haveBelongCompany: true,
      tableColumn: [
        {
          label: "订单编号",
          prop: "orderNo",
          align: "left",
          show: true,
        },
        {
          label: "服务商",
          prop: "driverCompanyName",
          align: "left",
          show: true,
        },
        {
          label: "司机姓名",
          prop: "driverName",
          align: "left",
          show: true,
        },
        {
          label: "司机联系方式",
          prop: "driverPhone",
          align: "left",
          show: true,
        },
        {
          label: "货物名称",
          prop: "cargoName",
          align: "left",
          show: true,
        },
        {
          label: "装货地",
          prop: "startProvinceName",
          align: "left",
          scopeStatus: true,
          show: true,
        },
        {
          label: "卸货地",
          prop: "endProvinceName",
          align: "left",
          scopeStatus: true,
          show: true,
        },
        {
          label: "回单方式",
          prop: "receiptWay",
          align: "left",
          scopeStatus: true,
          show: true,
        },
        {
          label: "操作",
          prop: "operation",
          fixed: "right",
          width: "160px",
          scopeStatus: true,
          show: true,
        },
      ],
      unConfirm:null,
      statisticsImage1: require("@/assets/imgs/huozhuzongliang.png"),
      statisticsImage2: require("@/assets/imgs/youxiaohuozhu.png"),
      statisticsImage3: require("@/assets/imgs/xiadanbishu.png"),
      statisticsImage4: require("@/assets/imgs/dingdanwancheng.png"),
      statisticsImage5: require("@/assets/imgs/leijijine.png"),
    };
  },
  created() {
    this.getDeptData()
  },
  mounted() {},
  methods: {
    getDeptData() {
      getOverview(this.searchForm).then((res) => {
        if (res.code === 200) {
          this.unConfirm = res.data.unConfirm;
        }
      });
    },
    handleGenDan(row) {
      this.$refs.addOrEdit.init("回单订单跟单", false, row);
    },
    openDetail(row) {
      this.$refs.addOrEdit.init("回单订单跟单详情", true, row);
    },
  },
};
</script>
<style lang="scss" scoped>
.order-management {
  .search-form-title {
    font-weight: 400;
    font-size: 0.16rem;
    color: #111827;
    line-height: 0.24rem;
    padding-bottom: 0.08rem;
  }
  .custom-tip {
    font-size: 0.16rem;
    padding: 0.16rem 0.2rem;
    background: rgba(18, 105, 255, 0.05);
    box-sizing: border-box;
    margin: 0 0.16rem;
    border-radius: 0.03rem;
    border: 0.01rem dashed #1269ff;
  }
  .drop-image {
    width: 0.24rem;
    height: 0.24rem;
  }

  .owner-requirement {
    background-color: rgba(217, 236, 255, 0.5);
    color: #1269ff;
    padding: 0.05rem;
    border-radius: 0.06rem;
  }

  .mileage {
    position: relative;
    padding: 0 0.05rem 0.06rem;
  }

  .mileage::after {
    content: "→";
    position: absolute;
    left: 0;
    bottom: -0.06rem;
    text-align: center;
    width: 100%;
  }
}
</style>
